var map = {
	"./marker-point-amarillo.png": "07cb",
	"./marker-point-azul-claro.png": "59ac",
	"./marker-point-azul.png": "5fad",
	"./marker-point-cyan.png": "16d8",
	"./marker-point-gris.png": "d636",
	"./marker-point-indigo.png": "684c",
	"./marker-point-marron.png": "ec9a",
	"./marker-point-naranja-oscuro.png": "b446",
	"./marker-point-naranja.png": "965a",
	"./marker-point-purpura-oscuro.png": "7803",
	"./marker-point-purpura.png": "81b9",
	"./marker-point-rojo.png": "3830",
	"./marker-point-rosa.png": "a80d",
	"./marker-point-verde-azulado.png": "6ec2",
	"./marker-point-verde-claro.png": "c0b9",
	"./marker-point-verde-lima.png": "26cc",
	"./marker-point-verde.png": "0f60",
	"./position-sivigila.png": "a57d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad0c";